define('modules/options-menu',['jquery'], function ($) {
  /**
   * @class OptionsMenu
   */
  return (function () {
    /**
     * @constructor
     */
    function OptionsMenu() {}

    /**
     * Open and close menu
     *
     * @method toggle
     * @param e
     */
    OptionsMenu.prototype.toggle = function (e) {
      $(e.currentTarget).toggleClass('open');
    };

    OptionsMenu.prototype.addBodyCloseListener = function (selector) {
      $(document).on('click', function (e) {
        if (!$(e.target).is(selector) && !$(e.target).closest(selector).length) {
          $(selector).removeClass('open');
        }
      });
    };

    return new OptionsMenu();
  })();
});

